/**
 * Check-report finding texts (spec section 7.5), one per FindingCode of contracts
 * section 2.4. Placeholders are exactly the `params` keys the intake engine emits
 * (plan C, libs/cad-intake), never CAD text. ms and zh use the same placeholders
 * (planning-console-keys.spec.ts).
 */
export default {
  FORMAT_UNSUPPORTED: 'The file is not a supported drawing. Save it as an AutoCAD 2000 (R2000) DWG or as a DXF.',
  READ_FAILED: 'The drawing could not be read.',
  LAYER_MISSING: 'Required layer {{layer}} is missing.',
  SITE_BOUNDARY_COUNT: 'Layer {{layer}} must hold exactly one site boundary; it holds {{count}}.',
  CHECK_SKIPPED: 'Checks that need the site boundary were skipped: {{checks}}.',
  BOUNDARY_NOT_CLOSED: 'The site boundary on {{layer}} has a gap of {{gap_m}} m (tolerance {{tolerance_m}} m).',
  BLOCK_REFERENCE_PRESENT: 'Layer {{layer}} contains {{count}} block references, which are not allowed.',
  LAYER_HIDDEN: 'Required layer {{layer}} is hidden ({{state}}); it was read anyway.',
  UNITS_SUSPECT: 'The site is {{span_m}} m across, outside {{min_m}} to {{max_m}} m. Check the drawing units.',
  OUTSIDE_JURISDICTION: 'Read in EPSG:{{srid}}, the site falls outside the jurisdiction. Check the coordinate system.',
  JURISDICTION_NOT_CONFIGURED: 'No jurisdiction boundary is configured, so the site location was not checked.',
  DATUM_AMBIGUOUS:
    'EPSG:{{srid}} is easily confused with a neighbouring datum a few metres away. Confirm the coordinate system.',
  GEOMETRY_REPAIRED: '{{count}} geometries were repaired automatically.',
  GEOMETRY_INVALID: '{{count}} geometries are invalid and could not be repaired.',
  OUTSIDE_SITE_IGNORED: '{{count}} features outside the site were ignored (title block, legend, insets).',
  BACKGROUND_FILL_DROPPED: '{{count}} background fills covering the site were dropped.',
  PLOT_EXCEEDS_SITE: '{{count}} plots extend beyond the site (largest overhang {{max_overhang_m2}} m²).',
  OVERLAP_RATE: 'Plots overlap by {{overlap_m2}} m² ({{pct}}% of the site).',
  SLIVER_GAPS: '{{count}} small gaps between plots ({{area_m2}} m² in total).',
  UNASSIGNED_AREA: '{{area_m2}} m² of the site is not covered by any plot; it was assigned to {{class}}.',
  LABEL_UNMATCHED: '{{count}} plots have no label matching the land-use code list.',
  AREA_MISMATCH: 'The site measures {{site_m2}} m² but {{declared_m2}} m² was declared ({{diff_pct}}% apart).',
  UNKNOWN_LAYERS: '{{count}} layers are not part of the plan standard: {{layers}}.',
  Z_FLATTENED: 'Elevations were dropped; the plan is read in 2D.',
} as const
